var React = require('react');

function Social (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.93478 7.45455C5.45608 7.45455 7.5 5.01246 7.5 2H5.06522C2.54392 2 0 4.44208 0 7.45455H2.93478ZM10.5 2C13.3815 2 16 4.44208 16 7.45455H13.7174C10.8359 7.45455 8.5 5.01246 8.5 2H10.5ZM7.5 14C7.5 10.9875 5.45608 8.54545 2.93478 8.54545H0C0 11.5579 2.54392 14 5.06522 14H7.5ZM14.8447 9.63636C14.322 11.4574 12.5445 12.9091 10.5 12.9091H9.63395C10.0988 11.0505 11.7232 9.63636 13.7174 9.63636H14.8447ZM13.7174 8.54545C11.1933 8.54545 9.08778 10.4194 8.60437 12.9091C8.53593 13.2616 8.5 13.6264 8.5 14H10.5C13.0241 14 15.3465 12.1261 15.8837 9.63636C15.9597 9.28388 16 8.91905 16 8.54545H13.7174Z","fill":"black"}));
}

Social.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Social;

Social.default = Social;
